import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";
import { inlineIconGlyphSize, inlineIconSize } from "@common/inlineIconSizes";

// Matches the link the select renders at the end of its input field, so a link on a text field and a link on a
// legal entity read as the same affordance.
export const useTextFieldWithLinkStyles = () => {
    const theme = useTheme();

    return createSxStyles({
        inlineLink: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            width: inlineIconSize,
            height: inlineIconSize,
            borderRadius: "5px",
            backgroundColor: theme.customPalette.collapseBackground,
            "& a": {
                display: "flex",
            },
            "& svg": {
                width: inlineIconGlyphSize,
                height: inlineIconGlyphSize,
            },
            "&:hover": {
                cursor: "pointer",
            },
        },
    });
};
